import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Welcome.module.scss';
import Button from '../../common/Button';

function Welcome(props) {
  return (
    <div className={styles.welcomeWrapper}>
      <h2>Welcome!</h2>

      <Link to="/signin">
        <Button full_width text="SIGN IN" />
      </Link>
    </div>
  );
}

export default Welcome;
